import docpcBlank from "@/doctor_pc/apply/blank.vue"; //跳转页
import docpcLogin from "@/doctor_pc/apply/login.vue"; //登录页
import docpcMsg from "@/doctor_pc/apply/msg.vue"; //消息页
import docpcApplyComplete from "@/doctor_pc/apply/complete.vue"; //完善信息页
import docpcApplySign from "@/doctor_pc/apply/sign.vue"; //医生签名页
import docpcApplyAttach from "@/doctor_pc/apply/attach.vue"; //认证材料上传页
import docpcExam from "@/doctor_pc/exam/home.vue"; //考试首页页
import docpcExamPage from "@/doctor_pc/exam/exam.vue"; //考试首页页
import docpcRecord from "@/doctor_pc/document/record.vue"; //备案页
import docpcSign from "@/doctor_pc/document/sign.vue"; //印章页
import docpcMemo from "@/doctor_pc/document/memo.vue"; //备忘录页

const dpcpcRoutes = [
  // 医生注册
  {
    path: "/docpc/login",
    name: "docpcLogin",
    component: docpcLogin,
    meta: {
      title: '医生登录'
    }
  },
  {
    path: "/docpc/",
    name: "docpcBlank",
    component: docpcBlank,
    meta: {
      title: '医生考试'
    }
  },
  {
    path: "/docpc/msg",
    name: "docpcMsg",
    component: docpcMsg,
    meta: {
      title: '医生考试'
    }
  },
  {
    path: "/docpc/apply/complete",
    name: "docpcApplyComplete",
    component: docpcApplyComplete,
    meta: {
      title: '信息填写'
    }
  },
  {
    path: "/docpc/apply/sign",
    name: "docpcApplySign",
    component: docpcApplySign,
    meta: {
      title: '医生签名'
    }
  },
  {
    path: "/docpc/apply/attach",
    name: "docpcApplyAttach",
    component: docpcApplyAttach,
    meta: {
      title: '认证材料上传'
    }
  },
  // 考试
  {
    path: "/docpc/exam",
    name: "docpcExam",
    component: docpcExam,
    meta: {
      title: '开始考试'
    }
  },
  {
    path: "/docpc/exam/page",
    name: "docpcExamPage",
    component: docpcExamPage,
    meta: {
      title: '医生考试'
    }
  },
  // 备案和印章
  {
    path: "/docpc/memo",
    name: "docpcMemo",
    component: docpcMemo,
    meta: {
      title: '医生备案'
    }
  },
  {
    path: "/docpc/record",
    name: "docpcRecord",
    component: docpcRecord,
    meta: {
      title: '医生备案'
    }
  },
  {
    path: "/docpc/sign",
    name: "docpcSign",
    component: docpcSign,
    meta: {
      title: '印章接收'
    }
  },
];

export default dpcpcRoutes;